import {UserAccountSummaryModel} from './userAccountSummary.model';

export class UserAccountModel {
    summary: UserAccountSummaryModel;
}
